<template>
  <div class="">

    <Head />


    <div class="main home">
      <AccesskeyLink target="accesskey_c" accesskey="c" :aria-label="$t('跳到中央內容區塊')">
        :::
      </AccesskeyLink>

      <VueSlickCarousel v-if="carouselItems.length > 0" class="carousel_box" data-layout-tab="Home" data-layout-item="Banner" :slidesToShow="1" :focusOnSelect="true" :autoplay="false" :arrows="true"
        :dots="true" :swipe="true" :draggable="true">
        <div v-for="(carousel, index) in carouselItems" :key="index">
          <a v-if="carousel.isExternal" :href="carousel.to" :target="carousel.target" :title="carousel.title">
            <div class="img_box" :style="{ backgroundImage: `url(${carousel.src})` }">
              <img :src="carousel.src" :alt="carousel.title" />
            </div>
          </a>
          <router-link v-else :to="carousel.to" :title="carousel.title">
            <div class="img_box" :style="{ backgroundImage: `url(${carousel.src})` }">
              <img :src="carousel.src" :alt="carousel.title" />
            </div>
          </router-link>
        </div>
      </VueSlickCarousel>

      <div class="bg"></div>

      <div v-if="activityItem.length > 0" class="activity_box" data-layout-tab="Home" data-layout-item="SpecialExhibition">
        <div class="container">

          <div class="title_box">
            <h2>{{ activityCategoryName }}</h2>
          </div>

          <ul class="activity_list">
            <li v-for="(item, index) in activityItem" :key="index">
              <a v-if="item.isExternal" class="activity" :href="item.to" :target="item.target" :title="item.title">

                <img :src="item.src" :alt="item.title + $t(' 圖片')">

                <div class="text_box">
                  <div :data-text="item.title" class="title">
                    <h3>{{ item.title }}</h3>
                    <p class="subtitle">{{ item.subtitle }}</p>
                  </div>
                  <p class="text">{{ item.text }}</p>
                </div>

                <div class="read_btn">
                  <p>{{ $t('READ MORE') }}</p>
                </div>
              </a>
              <router-link v-else class="activity" :to="item.to" :title="item.title">

                <img :src="item.src" :alt="item.title + $t(' 圖片')">

                <div class="text_box">
                  <div :data-text="item.title" class="title">
                    <h3>{{ item.title }}</h3>
                    <p class="subtitle">{{ item.subtitle }}</p>
                  </div>
                  <p class="text">{{ item.text }}</p>
                </div>

                <div class="read_btn">
                  <p>{{ $t('READ MORE') }}</p>
                </div>
              </router-link>
            </li>
          </ul>
        </div>
      </div>


      <div v-if="newsItem.length > 0" class="news_box" data-layout-tab="Home" data-layout-item="News">
        <div class="container">

          <div class="box">

            <div class="title_box">
              <h2>{{ newsCategoryName }}</h2>
            </div>

            <ul class="news_list">
              <li v-for="(item, index) in newsItem" :key="index">
                <a v-if="item.isExternal" class="news" :href="item.to" :target="item.target" :title="item.title">
                  <p class="time">{{ item.time }}</p>
                  <p class="title"> {{ item.title }}</p>
                </a>
                <router-link v-else class="news" :to="item.to" :title="item.title">
                  <p class="time">{{ item.time }}</p>
                  <p class="title"> {{ item.title }}</p>
                </router-link>
              </li>
            </ul>

            <div class="btn_box">
              <button v-if="newsCategoryId" class="more_btn" @click="gotoCategory(newsCategoryId)" :title="$t('更多最新消息（另開新視窗）')">
                <p>{{ $t('READ MORE') }}</p>
              </button>
            </div>

          </div>

        </div>
      </div>


      <div class="calendar_box" v-if="showCalendar" data-layout-tab="Home" data-layout-item="EventCalendar">

        <div class="container">

          <div class="title_box">
            <h2>{{ $t('活動行事曆') }}</h2>
          </div>

          <div class="calendar row">

            <div class="col-12 col-md-6" ref="calendar"></div>

            <!-- 下方活動列表 -->
            <div class="event_box col-12 col-md-6" v-if="selectedDate" :style="{ height: calendarOuterHeight + 'px' }">

              <div class="event_list">
                <h3>{{ selectedDate }}</h3>

                <!-- 休息日 -->
                <div v-if="isRestDay" class="closed_box">
                  <em>
                    <!-- 今日為休息日 -->
                    <img src="img/img_calendar.png" alt="">
                  </em>
                </div>

                <!-- 有活動 -->
                <ul class="event_box" v-else-if="selectedEvents.length > 0">
                  <li v-for="ev in selectedEvents" :key="ev.id">
                    <div class="text_box">
                      <p class="title">{{ $t('活動名稱') }}</p>
                      <p>{{ ev.title }}</p>
                    </div>

                    <div class="text_box">
                      <p class="title">{{ $t('活動日期') }}</p>
                      <p>{{ getEventDateString(ev) }}</p>
                    </div>

                    <div class="text_box">
                      <p class="title">{{ $t('活動地點') }}</p>
                      <p>{{ ev.place }}</p>
                    </div>

                    <div class="btn_box">
                      <router-link :to="ev.to" class="more_btn" :title="ev.title">
                        <p>{{ $t('READ MORE') }}</p>
                      </router-link>
                    </div>
                  </li>
                </ul>

                <!-- 無活動 -->
                <div v-else class="closed_box">
                  <em><img :src="$i18n.locale === 'en' ? 'img/img_calendar_2_en.png' : $i18n.locale === 'ja' ? 'img/img_calendar_2_jp.png' : 'img/img_calendar_2.png'" alt=""></em>
                </div>
              </div>

            </div>

          </div>
        </div>

      </div>


      <div v-if="linkItems.length > 0" class="quickLink_box" data-layout-tab="Home" data-layout-item="BottomMenu">

        <div class="container">

          <ul class="quickLink_list">
            <li v-for="(item, index) in linkItems" :key="index" @mouseenter="item.isHover = true"
              @mouseleave="item.isHover = false">
              <a v-if="item.isExternal" class="quickLink_btn" :class="item.className" :href="item.to" :target="item.target" :title="item.title + '(另開新視窗)'">
                <p>{{ item.title }}</p>
                <div class="img_box">
                  <img :src="item.isHover ? item.srcHover : item.src" alt="icon">
                </div>
              </a>
              <router-link v-else class="quickLink_btn" :class="item.className" :to="item.to" :title="item.title">
                <p>{{ item.title }}</p>
                <div class="img_box">
                  <img :src="item.isHover ? item.srcHover : item.src" alt="icon">
                </div>
              </router-link>
            </li>
          </ul>
        </div>
      </div>


    </div>

    <Footer />

  </div>
</template>

<script>
import Head from '@/components/Head.vue'
import Footer from '@/components/Footer.vue';

import AccesskeyLink from '@/views/AccesskeyLink.vue'

// 輪播
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'


import { Calendar } from '@fullcalendar/core'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import zhTw from "@fullcalendar/core/locales/zh-tw"  // 引入繁體中文
import ja from "@fullcalendar/core/locales/ja"          // 引入日文

// 行事曆休館日
const REST_DAY = 3 // 星期三


export default {
  name: 'Home',
  components: {
    Head,
    Footer,

    AccesskeyLink,

    VueSlickCarousel,

    Calendar,
    dayGridPlugin,
    timeGridPlugin,
    interactionPlugin,
    zhTw,

  },

  data() {
    return {


      // 輪播
      carouselItems: [],

      // 活動
      activityItem: [],
      activityCategoryName: '',

      // 最新消息
      newsItem: [],
      newsCategoryName: '',
      newsCategoryId: null,


      // 行事曆
      calendar: null,

      selectedDate: null,        // 使用者點擊的日期
      selectedEvents: [],        // 當天活動列表

      // 右側活動列表高度
      calendarOuterHeight: 0,

      isRestDay: false,   // ← 新增：是否為休息日

      // 所有活動資料（將由 API 載入）
      eventsData: [],

      // 連結區塊
      linkItems: [],

      // 是否顯示行事曆區塊
      showCalendar: false,
    };
  },


  async mounted() {
    // 先載入首頁資料（包括活動資料）
    await this.fetchHomeLayout()

    // 等資料載入完成後再初始化行事曆
    this.initCalendar()

    // 初次載入顯示今天活動
    const today = new Date()
    this.autoSelectToday(today)

    // 等 Calendar render 完後綁定 today 按鈕
    this.$nextTick(() => {
      this.bindTodayButton()
    })
  },

  watch: {
    '$i18n.locale': async function() {
      // 語系切換時重新載入所有首頁資料
      await this.fetchHomeLayout();
      
      // 重新初始化行事曆
      if (this.calendar) {
        this.calendar.destroy();
      }
      this.initCalendar();
      this.autoSelectToday(new Date());
    }
  },

  methods: {

    async applyLayoutVisualItem({ tabKey, item }) {
      if (tabKey !== 'Home') return;
      switch (item.itemKey) {
        case 'Banner':
          item.referenceId ? await this.fetchBannerData(item.referenceId) : (this.carouselItems = []);
          break;
        case 'SpecialExhibition':
          item.referenceId ? await this.fetchActivityData(item.referenceId) : (this.activityItem = []);
          break;
        case 'News':
          item.referenceId ? await this.fetchNewsData(item.referenceId) : (this.newsItem = []);
          break;
        case 'BottomMenu':
          item.referenceId ? await this.fetchBottomMenuData(item.referenceId) : (this.linkItems = []);
          break;
        case 'EventCalendar':
          this.showCalendar = Boolean(item.referenceId);
          if (item.referenceId) {
            await this.fetchEventCalendarData(item.referenceId);
            if (this.calendar) this.calendar.destroy();
            this.initCalendar();
            this.autoSelectToday(new Date());
          } else {
            this.eventsData = [];
            if (this.calendar) {
              this.calendar.destroy();
              this.calendar = null;
            }
          }
          break;
      }
    },

    // 取得對應 FullCalendar locale 物件
    getCalendarLocale() {
      if (this.$i18n.locale === 'ja') return ja;
      if (this.$i18n.locale === 'en') return 'en'; // FullCalendar 預設英文，傳字串即可
      return zhTw; // 預設繁體中文
    },

    // 轉換前端語系名稱為後端格式
    convertLocaleForBackend(frontendLocale) {
      const localeMap = {
        'zh-TW': 'zh-tw',
        'en': 'en-us',
        'ja': 'ja-jp'
      };
      return localeMap[frontendLocale] || 'zh-tw';
    },
    // API: 取得首頁版面配置
    async fetchHomeLayout() {
      try {
        const backendLocale = this.convertLocaleForBackend(this.$i18n.locale);
        const apiUrl = `${this.$store.state.src}${this.$store.state.subDirectory}/Frontend/GetLayout?TabKey=Home&locale=${backendLocale}`;
        const response = await fetch(apiUrl);
        
        if (!response.ok) {
          console.warn('無法取得首頁版面配置，清空所有資料');
          // 清空所有首頁資料
          this.carouselItems = [];
          this.activityItem = [];
          this.newsItem = [];
          this.linkItems = [];
          this.eventsData = [];
          return;
        }
        
        const layout = await response.json();
        
        // 先清空所有資料，避免舊資料殘留
        this.carouselItems = [];
        this.activityItem = [];
        this.activityCategoryName = '';
        this.newsItem = [];
        this.newsCategoryName = '';
        this.newsCategoryId = null;
        this.linkItems = [];
        this.eventsData = [];
        this.showCalendar = false;
        
        if (layout.layoutItems && Array.isArray(layout.layoutItems)) {
          // 處理各個區塊
          for (const item of layout.layoutItems) {
            switch (item.itemKey) {
              case 'Banner':
                if (item.referenceId) {
                  await this.fetchBannerData(item.referenceId);
                }
                break;
              case 'SpecialExhibition':
                if (item.referenceId) {
                  await this.fetchActivityData(item.referenceId);
                }
                break;
              case 'News':
                if (item.referenceId) {
                  await this.fetchNewsData(item.referenceId);
                }
                break;
              case 'BottomMenu':
                if (item.referenceId) {
                  await this.fetchBottomMenuData(item.referenceId);
                }
                break;
              case 'EventCalendar':
                if (item.referenceId) {
                  this.showCalendar = true;
                  await this.fetchEventCalendarData(item.referenceId);
                }
                break;
            }
          }
        }
      } catch (error) {
        console.error('載入首頁版面配置失敗:', error);
        // 清空所有首頁資料
        this.carouselItems = [];
        this.activityItem = [];
        this.newsItem = [];
        this.linkItems = [];
        this.eventsData = [];
      }
    },

    // API: 取得橫幅資料
    async fetchBannerData(categoryId) {
      try {
        const backendLocale = this.convertLocaleForBackend(this.$i18n.locale);
        const apiUrl = `${this.$store.state.src}${this.$store.state.subDirectory}/Frontend/GetCategoryData?CId=${categoryId}&IncludePost=true&locale=${backendLocale}`;
        const response = await fetch(apiUrl);
        
        if (!response.ok) {
          console.warn('無法取得橫幅資料，清空輪播資料');
          this.carouselItems = [];
          return;
        }
        
        const category = await response.json();
        
        if (category.Posts && Array.isArray(category.Posts)) {
          this.carouselItems = category.Posts.map(post => ({
            src: post.image ? `${this.$store.state.src}${this.$store.state.subDirectory}${post.image}` : require('/public/img/banner_1.png'),
            title: post.title,
            to: post.type === 2 ? post.url : `/Post/${post.pId}`,
            isExternal: post.type === 2,
            target: (post.type === 2 && post.blank) ? '_blank' : '_self'
          }));
        } else {
          this.carouselItems = [];
        }
      } catch (error) {
        console.error('載入橫幅資料失敗:', error);
        this.carouselItems = [];
      }
    },

    // API: 取得活動資料
    async fetchActivityData(categoryId) {
      try {
        const backendLocale = this.convertLocaleForBackend(this.$i18n.locale);
        const apiUrl = `${this.$store.state.src}${this.$store.state.subDirectory}/Frontend/GetCategoryData?CId=${categoryId}&IncludePost=true&locale=${backendLocale}`;
        const response = await fetch(apiUrl);
        
        if (!response.ok) {
          console.warn('無法取得活動資料，清空活動資料');
          this.activityItem = [];
          this.activityCategoryName = '';
          return;
        }
        
        const category = await response.json();
        
        // 設定分類名稱
        this.activityCategoryName = category.Title || this.$t('特展活動專區');
        
        if (category.Posts && Array.isArray(category.Posts)) {
          this.activityItem = category.Posts.map(post => ({
            title: post.title,
            subtitle: '',  // 暫時留空
            text: post.simpleContent || '',
            to: post.type === 2 ? post.url : `/Post/${post.pId}`,
            isExternal: post.type === 2,
            target: (post.type === 2 && post.blank) ? '_blank' : '_self',
            src: post.image ? `${this.$store.state.src}${this.$store.state.subDirectory}${post.image}` : require('/public/img/img_1.png')
          }));
        } else {
          this.activityItem = [];
        }
      } catch (error) {
        console.error('載入活動資料失敗:', error);
        this.activityItem = [];
        this.activityCategoryName = '';
      }
    },

    // API: 取得最新消息資料
    async fetchNewsData(categoryId) {
      try {
        const backendLocale = this.convertLocaleForBackend(this.$i18n.locale);
        const apiUrl = `${this.$store.state.src}${this.$store.state.subDirectory}/Frontend/GetCategoryData?CId=${categoryId}&IncludePost=true&locale=${backendLocale}`;
        const response = await fetch(apiUrl);
        
        if (!response.ok) {
          console.warn('無法取得最新消息資料，清空最新消息資料');
          this.newsItem = [];
          this.newsCategoryName = '';
          this.newsCategoryId = null;
          return;
        }
        
        const category = await response.json();
        
        // 設定分類名稱和 ID
        this.newsCategoryName = category.Title || this.$t('最新消息');
        this.newsCategoryId = category.CId;
        
        if (category.Posts && Array.isArray(category.Posts)) {
          this.newsItem = category.Posts.map(post => ({
            time: this.formatDate(post.createTime),
            title: post.title,
            to: post.type === 2 ? post.url : `/Post/${post.pId}`,
            isExternal: post.type === 2,
            target: (post.type === 2 && post.blank) ? '_blank' : '_self'
          }));
        } else {
          this.newsItem = [];
        }
      } catch (error) {
        console.error('載入最新消息資料失敗:', error);
        this.newsItem = [];
        this.newsCategoryName = '';
        this.newsCategoryId = null;
      }
    },

    // API: 取得底部選單資料
    async fetchBottomMenuData(menuId) {
      try {
        const backendLocale = this.convertLocaleForBackend(this.$i18n.locale);
        const apiUrl = `${this.$store.state.src}${this.$store.state.subDirectory}/Frontend/GetMenuData?MEId=${menuId}&locale=${backendLocale}`;
        const response = await fetch(apiUrl);
        
        if (!response.ok) {
          console.warn('無法取得底部選單資料，清空連結資料');
          this.linkItems = [];
          return;
        }
        
        const menu = await response.json();
        
        if (menu.data && Array.isArray(menu.data)) {
          // 只取第一層選單
          this.linkItems = menu.data.map(item => ({
            title: item.text,
            to: this.generateLink(item.data),
            isExternal: item.data?.type === 3,
            target: item.data?.target || '_blank',
            src:  item.data?.buttonImage ? `${this.$store.state.src}${this.$store.state.subDirectory}${item.data?.buttonImage}` : '',  // 圖片位置留空
            srcHover: item.data?.buttonImageHover ? `${this.$store.state.src}${this.$store.state.subDirectory}${item.data?.buttonImageHover}` : '',  // 圖片位置留空
            isHover: false,
            className: item.data?.extraClasses ? item.data?.extraClasses : ''
          }));
        } else {
          this.linkItems = [];
        }
      } catch (error) {
        console.error('載入底部選單資料失敗:', error);
        this.linkItems = [];
      }
    },

    // API: 取得行事曆活動資料
    async fetchEventCalendarData(categoryId) {
      try {
        // 取得當前月份的第一天和最後一天
        const now = new Date();
        const firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
        const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0);
        
        // 格式化日期為 yyyy-MM-dd
        const startDate = this.formatDateForAPI(firstDay);
        const endDate = this.formatDateForAPI(lastDay);
        
        const backendLocale = this.convertLocaleForBackend(this.$i18n.locale);
        const apiUrl = `${this.$store.state.src}${this.$store.state.subDirectory}/Frontend/GetCategoryData?CId=${categoryId}&IncludePost=true&StartDate=${startDate}&EndDate=${endDate}&locale=${backendLocale}`;
        const response = await fetch(apiUrl);
        
        if (!response.ok) {
          console.warn('無法取得行事曆活動資料，清空行事曆資料');
          this.eventsData = [];
          return;
        }
        
        const category = await response.json();
        
        if (category.Posts && Array.isArray(category.Posts)) {
          // 將文章資料轉換為行事曆活動格式
          this.eventsData = [];
          
          category.Posts.forEach(post => {
            if (post.eventDates && Array.isArray(post.eventDates) && post.eventDates.length > 0) {
              // 收集所有活動日期，如果有範圍則展開成每一天
              const dates = [];
              
              post.eventDates.forEach(ed => {
                const startDate = new Date(ed.startDateTime);
                
                if (ed.endDateTime) {
                  // 有結束日期，展開範圍內的所有日期
                  const endDate = new Date(ed.endDateTime);
                  const currentDate = new Date(startDate);
                  
                  while (currentDate <= endDate) {
                    dates.push(this.formatDateForAPI(new Date(currentDate)));
                    currentDate.setDate(currentDate.getDate() + 1);
                  }
                } else {
                  // 沒有結束日期，只有單日
                  dates.push(this.formatDateForAPI(startDate));
                }
              });
              
              this.eventsData.push({
                id: post.pId.toString(),
                title: post.title,
                dates: dates,
                eventDates: post.eventDates, // 保存原始的 eventDates 資訊
                place: post.eventLocation || this.$t('未指定地點'),
                to: `/Post/${post.pId}`,
                allDay: true
              });
            }
          });
        } else {
          this.eventsData = [];
        }
      } catch (error) {
        console.error('載入行事曆活動資料失敗:', error);
        this.eventsData = [];
      }
    },

    // 格式化日期為 API 所需格式 (yyyy-MM-dd)
    formatDateForAPI(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },

    // 根據 data.type 產生對應的連結
    generateLink(data) {
      if (!data) return '#';

      switch (data.type) {
        case 0:
          // 目錄，不產生連結
          return '';
        case 1:
          // 文章分類
          return data.cid ? `/Category/${data.cid}` : '';
        case 2:
          // 文章
          return data.pid ? `/Post/${data.pid}` : '';
        case 3:
          // 外部連結
          return data.url || '';
        default:
          return '';
      }
    },

    // 格式化日期
    formatDate(dateString) {
      if (!dateString) return '';
      
      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      
      return `${year}/${month}/${day}`;
    },

    initCalendar() {

      const isMobile = window.innerWidth < 767.98;

      this.calendar = new Calendar(this.$refs.calendar, {
        plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],

        headerToolbar: isMobile
          ? { left: 'title', center: '', right: 'prev today next' }
          : { left: 'prev', center: 'title', right: 'today next' },

        initialView: isMobile ? 'dayGridWeek' : 'dayGridMonth',

        locale: this.getCalendarLocale(),

        // ★ RWD：初次載入就決定看月或周
        initialView: window.innerWidth < 767.98 ? 'dayGridWeek' : 'dayGridMonth',
        // initialView: "dayGridMonth",

        height: "auto",            // ← 不要固定高度
        contentHeight: "auto",     // ← 自動撐開
        expandRows: true,          // ← 顯示完整月曆


        // 不在月曆上渲染事件（你需要純樣式）
        events: [],

        // 日期渲染回呼 → 用來改變日期樣式
        dayCellDidMount: this.decorateDay,

        // 點擊日期
        dateClick: this.handleDateClick,

        // 修改日期 拿掉日
        dayCellContent: function (arg) {
          return {
            html: `<div class="fc-daygrid-day-number fc-day-number-only">${arg.date.getDate()}</div>`
          }
        },

        // ★ RWD：視窗變動時切換 view
        windowResize: (arg) => {
          if (window.innerWidth < 767.98) {
            this.calendar.changeView('dayGridWeek')
          } else {
            this.calendar.changeView('dayGridMonth')
          }
        },

        // 每次 FullCalendar 完成渲染，就能抓到正確高度
        datesSet: () => {
          this.$nextTick(() => {
            setTimeout(() => {
              this.updateOuterHeight();
              // 強制重新套用所有日期的樣式
              this.reapplyAllDayStyles();
            }, 30);
          })
        },
      })

      this.calendar.render()
    },

    // 標記日期樣式：有活動 / 無活動 / 休息日
    decorateDay(info) {
      // 取得本地日期 YYYY-MM-DD
      const localDate = info.date.getFullYear() + '-' +
        String(info.date.getMonth() + 1).padStart(2, '0') + '-' +
        String(info.date.getDate()).padStart(2, '0')

      const hasEvent = this.hasEventOnDate(localDate)

      // 找到放日期的元素
      const dayTop = info.el.querySelector('.fc-day-number-only')
      const frame = info.el.querySelector('.fc-daygrid-day-frame')

      if (!frame) return

      this.updateEventLabel(dayTop, hasEvent)

      // --- 優先檢查是否有活動 ---
      if (hasEvent) {
        // 移除其他可能的 class，確保樣式統一
        frame.classList.remove('closed-off', 'no-event')
        // 加上有活動的 class
        frame.classList.add('has-event')
        
        // 如果是星期三且有「休館」文字，移除它
        if (info.date.getDay() === REST_DAY && dayTop) {
          const restLabel = dayTop.querySelector('.rest-label')
          if (restLabel) {
            restLabel.remove()
          }
        }
      }
      // --- 休息日（每週三）但沒有活動 → 套用休息日外觀 ---
      else if (info.date.getDay() === REST_DAY) {
        // 移除其他可能的 class
        frame.classList.remove('has-event', 'no-event')
        // 加上休息日 class
        frame.classList.add('closed-off')

        if (dayTop) {
          // 加上「休館」文字（避免重複添加）
          if (!dayTop.querySelector('.rest-label')) {
            const restTag = document.createElement('span')
            restTag.classList.add('rest-label')
            restTag.textContent = this.$t('休館')
            dayTop.appendChild(restTag)
          }
        }
      }
      // --- 無活動 ---
      else {
        // 移除其他可能的 class
        frame.classList.remove('has-event', 'closed-off')
        // 加上無活動 class
        frame.classList.add('no-event')
      }
    },

    // 顯示或移除日期格中的活動提示文字
    updateEventLabel(dayTop, hasEvent) {
      if (!dayTop) return

      const eventLabel = dayTop.querySelector('.event-label')

      if (hasEvent && !eventLabel) {
        const label = document.createElement('span')
        const fullLabel = document.createElement('span')
        const shortLabel = document.createElement('span')

        label.classList.add('event-label')
        fullLabel.classList.add('event-label-full')
        shortLabel.classList.add('event-label-short')
        fullLabel.textContent = this.$t('有活動!')
        shortLabel.textContent = this.$t('活動')

        label.appendChild(fullLabel)
        label.appendChild(shortLabel)
        dayTop.appendChild(label)
      } else if (!hasEvent && eventLabel) {
        eventLabel.remove()
      }
    },

    // 點擊日期
    handleDateClick(info) {
      const clickedDate = info.date.getFullYear() + '-' +
        String(info.date.getMonth() + 1).padStart(2, '0') + '-' +
        String(info.date.getDate()).padStart(2, '0')

      this.selectedDate = clickedDate

      // 新增：判斷禮拜幾（0 = 日, 1 = 一, 2 = 二 ... 6 = 六）
      const dayOfWeek = info.date.getDay()

      // 先檢查是否有活動
      const hasEvent = this.hasEventOnDate(clickedDate)

      // ★ 判斷是否為星期三且沒有活動時才顯示為休息日
      this.isRestDay = (dayOfWeek === REST_DAY && !hasEvent)

      if (this.isRestDay) {
        // ← 重點：休息日不要塞 selectedEvents
        this.selectedEvents = []
      } else {
        // 原本活動邏輯
        this.selectedEvents = this.eventsData.filter(ev => {
          if (ev.dates) {
            return ev.dates.includes(clickedDate)
          } else {
            return clickedDate >= ev.start && clickedDate <= ev.end
          }
        })
      }

      // 新增：標記這天為選取的日期
      this.highlightSelectedDate(clickedDate)
    },

    // 混合判斷（start~end + dates 陣列）
    hasEventOnDate(dateStr) {
      return this.eventsData.some(ev => {
        if (ev.dates) {
          // 非連續日期
          return ev.dates.includes(dateStr)
        } else {
          // 跨天或單日 start~end
          return dateStr >= ev.start && dateStr <= ev.end
        }
      })
    },

    // 標記被點到的日期
    highlightSelectedDate(dateStr) {
      // 先把舊的選取 class 拿掉
      document.querySelectorAll('.fc-daygrid-day.selected-day')
        .forEach(el => el.classList.remove('selected-day'))

      // 找到當天的格子
      const cell = document.querySelector(`.fc-daygrid-day[data-date="${dateStr}"]`)

      if (cell) {
        cell.classList.add('selected-day')
      }
    },

    autoSelectToday(date) {
      const clickedDate = date.getFullYear() + '-' +
        String(date.getMonth() + 1).padStart(2, '0') + '-' +
        String(date.getDate()).padStart(2, '0')

      this.selectedDate = clickedDate

      const dayOfWeek = date.getDay()

      // 先檢查是否有活動
      const hasEvent = this.hasEventOnDate(clickedDate)

      // 是否為休息日（星期三且沒有活動）
      this.isRestDay = (dayOfWeek === REST_DAY && !hasEvent)

      if (this.isRestDay) {
        this.selectedEvents = []
      } else {
        this.selectedEvents = this.eventsData.filter(ev => {
          if (ev.dates) return ev.dates.includes(clickedDate)
          return clickedDate >= ev.start && clickedDate <= ev.end
        })
      }

      // 新增：也高亮今天
      this.highlightSelectedDate(clickedDate)
    },

    bindTodayButton() {
      const todayBtn = document.querySelector('.fc-today-button')

      if (todayBtn) {
        todayBtn.addEventListener('click', () => {
          this.autoSelectToday(new Date()) // today 按鈕 → 回到今天活動
        })
      }
    },

    // 同步右側活動列表高度
    updateOuterHeight() {
      const root = this.$refs.calendar;

      if (!root) return;

      const harness = root.querySelector(".fc-view-harness");
      const toolbar = root.querySelector(".fc-header-toolbar");

      if (!harness) return;

      const harnessHeight = harness.offsetHeight;
      const toolbarHeight = toolbar ? toolbar.offsetHeight : 0;

      this.calendarOuterHeight = harnessHeight + toolbarHeight + 3;
    },

    // 重新套用所有日期的樣式（用於切換月份後）
    reapplyAllDayStyles() {
      const root = this.$refs.calendar;
      if (!root) return;

      // 找到所有日期格子
      const dayCells = root.querySelectorAll('.fc-daygrid-day');
      
      dayCells.forEach(cell => {
        const dateStr = cell.getAttribute('data-date');
        if (!dateStr) return;

        const hasEvent = this.hasEventOnDate(dateStr);
        const frame = cell.querySelector('.fc-daygrid-day-frame');
        const dayTop = cell.querySelector('.fc-day-number-only');
        
        if (!frame) return;

        this.updateEventLabel(dayTop, hasEvent);

        // 取得是星期幾
        const date = new Date(dateStr);
        const dayOfWeek = date.getDay();

        // 套用樣式
        if (hasEvent) {
          // 有活動：移除其他 class，只保留 has-event
          frame.classList.remove('closed-off', 'no-event');
          frame.classList.add('has-event');
          
          // 如果是星期三且有「休館」文字，移除它
          if (dayOfWeek === REST_DAY && dayTop) {
            const restLabel = dayTop.querySelector('.rest-label');
            if (restLabel) {
              restLabel.remove();
            }
          }
        } else if (dayOfWeek === REST_DAY) {
          // 休息日（無活動）
          frame.classList.remove('has-event', 'no-event');
          frame.classList.add('closed-off');

          if (dayTop && !dayTop.querySelector('.rest-label')) {
            const restTag = document.createElement('span');
            restTag.classList.add('rest-label');
            restTag.textContent = this.$t('休館');
            dayTop.appendChild(restTag);
          }
        } else {
          // 一般無活動日
          frame.classList.remove('has-event', 'closed-off');
          frame.classList.add('no-event');
        }
      });
    },

    // 解析活動日期文字
    getEventDateString(ev) {
      // 如果有原始 eventDates 資訊，優先使用
      if (ev.eventDates && Array.isArray(ev.eventDates) && ev.eventDates.length > 0) {
        // 將所有日期範圍轉換為字串
        const dateRanges = ev.eventDates.map(ed => {
          const startDate = this.formatDateForAPI(new Date(ed.startDateTime));
          
          if (ed.endDateTime) {
            const endDate = this.formatDateForAPI(new Date(ed.endDateTime));
            // 如果開始和結束是同一天，只顯示一個日期
            if (startDate === endDate) {
              return startDate;
            }
            return `${startDate}~${endDate}`;
          } else {
            // 沒有結束日期，只顯示開始日期
            return startDate;
          }
        });
        
        // 用逗號和空格分隔多個日期範圍
        return dateRanges.join(', ');
      }
      
      // 備用：如果沒有 eventDates，使用 dates 陣列
      if (ev.dates && Array.isArray(ev.dates)) {
        return ev.dates.join(', ');
      }

      // 備用：舊格式 start ~ end
      if (ev.start && ev.end) {
        if (ev.start === ev.end) return ev.start;
        return `${ev.start} ~ ${ev.end}`;
      }

      return '';
    },


    gotoPage(path) {
      if (this.$route.path !== path) {
        this.$router.push(path);
      }
    },

    gotoCategory(categoryId) {
      const path = `#/Category/${categoryId}`;
      window.open(path, '_blank');
    },


  },

}

</script>
